import axios from "axios";
import Cookies from "js-cookie";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthToken = () =>
    localStorage.getItem("authToken") || Cookies.get("authToken");

const getOfficeCodes = () => {
    const raw = Cookies.get("officeCodes");
    if (!raw) return "";
    return raw
        .split(",")
        .filter(Boolean)
        .map(code => `officeCodes=${encodeURIComponent(code)}`)
        .join("&");
};


export const getCurrentOrgInfo = () => {
    const orgDataRaw = localStorage.getItem("organizationData");
    if (!orgDataRaw) return {orgId: null, officeCode: null};
    try {
        const orgData = JSON.parse(orgDataRaw);
        // If orgData is an array, get the first item
        const firstOrg = Array.isArray(orgData) ? orgData[0] : orgData;
        return {
            orgId: firstOrg.orgId || null,
            officeCode: firstOrg.officeCode || null,
        };
    } catch {
        return {orgId: null, officeCode: null};
    }
};

export const fetchTeamMembers = async (officeCode, token) => {
    const officeCodesRaw = Cookies.get("officeCodes");
    const params = officeCodesRaw
        ? officeCodesRaw.split(",").filter(Boolean).map(code => `officeCodes=${encodeURIComponent(code)}`).join("&")
        : "";

    return axios.get(`${API_BASE_URL}/api/organizations/users/by-office-codes?${params}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
}

export const blockUser = async (email, token) =>
    axios.post(`${API_BASE_URL}/auth/user/blockUser?email=${email}`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
export const unBlockUser = async (email, token) =>
    axios.post(`${API_BASE_URL}/auth/user/unBlockUser?email=${email}`, {}, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

export const viewUserProfile = async (email) => {
    const token = Cookies.get("authToken");
    return axios.get(`${API_BASE_URL}/auth/user/viewprofile`, {
        params: {userEmail: email},
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const getUserPreferences = async () => {
    const token = getAuthToken();
    return axios.get(`${API_BASE_URL}/api/notifications/user_preferences/user`, {  
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const updateUserPreferences = async (category, isEnabled) => {
    const token = getAuthToken();
    return axios.patch(`${API_BASE_URL}/api/notifications/user_preferences/user/set_enabled`, {}, {
        params: {
            enabled: isEnabled,
            category: category
        },
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

export const viewOrganizationById = async (orgId) => {
    const token = getAuthToken();
    return axios.get(`${API_BASE_URL}/api/organizations/${orgId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};


//  Search Users with Filters
// ======================================================
export const searchUsers = async (filters = {}, page = 0, size = 10) => {
    const token = Cookies.get("authToken") || localStorage.getItem("authToken");

    const params = {
        searchTerm: filters.searchTerm || "",
        officeCodes:
            filters.offices?.length > 0
                ? filters.offices
                : (Cookies.get("officeCodes")
                    ? Cookies.get("officeCodes").split(",").filter(Boolean)
                    : []),

        roleIds:
            filters.roles?.length > 0
                ? filters.roles.map((r) => (typeof r === "object" ? r.id : r))
                : [],
        status: filters.status || "",
        sortBy:
            filters.sortBy === "Name (A–Z)"
                ? ["firstName"]
                : filters.sortBy === "Recently Added"
                    ? ["createdAt,desc"]
                    : [],
        page,
        size,
    };

    const paramsSerializer = {
        serialize: (params) => {
            const query = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((v) => query.append(key, v)); // ✅ repeated param
                } else if (value !== undefined && value !== "") {
                    query.append(key, value);
                }
            });
            return query.toString();
        },
    };

    return axios.get(`${API_BASE_URL}/auth/user/search`, {
        params,
        paramsSerializer, // ✅ important!
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};


// Search Organizations (Preferred Partners)
export const searchOrganizations = async (searchTerm, page = 0, size = 10) => {
    const token = Cookies.get("authToken") || localStorage.getItem("authToken");
    return axios.get(`${API_BASE_URL}/api/organizations/search`, {
        params: {searchTerm, page, size},
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });
};

// export const 


// http://localhost:8080/api/onboarding/add-users?officeCode=ASCENDCARGO
export const fetchPendingInvites = async (officeCode) =>
    axios.get(`/api/onboarding/pending-invites?officeCode=${officeCode}`);

export const resendInvite = async (officeCode, email) =>
    axios.post(`/api/onboarding/resend-invite?officeCode=${officeCode}`, {email});

export const uploadBulkUsers = async (officeCode, users) =>
    axios.post(`${API_BASE_URL}/api/onboarding/add-users?officeCode=${officeCode}`,
        users,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            },
        }
    );

export const createOrgInvite = async (officeCode, inviteType, validity, email, scacCode) =>
    axios.post(
        `${API_BASE_URL}/api/invites/create`,
        {}, {
            headers: {Authorization: `Bearer ${localStorage.getItem("authToken") || Cookies.get("authToken")}`},
            params: {
                originalOfficeCode: officeCode,
                inviteType,
                validUntilDate: validity,
                recipientEmail: email,
                scacCode: scacCode,
            },
        }
    );

export const fetchOrgInvites = async (officeCode) =>

    axios.get(`${API_BASE_URL}/api/invites/list?${getOfficeCodes()}`,
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
        }
    );
export const cancelOrgInvite = async (row) =>
    axios.post(
        `${API_BASE_URL}/api/invites/cancel?inviteCode=${row.uuid}`,
        {},
        {
            headers: {Authorization: `Bearer ${getAuthToken()}`}
        }
    );


//pref Partners apis


export const fetchPreferredPartners = (officeCode) =>
    axios.get(`${API_BASE_URL}/api/pref-partners/${officeCode}`, {
        headers: {Authorization: `Bearer ${getAuthToken()}`},
    });

export const addPreferredPartner = (officeCode, partnerCode) =>
    axios.post(
        `${API_BASE_URL}/api/pref-partners/${officeCode}`,
        [partnerCode],
        {headers: {"Content-Type": "application/json"}}
    );

export const deletePreferredPartner = (officeCode, partnerCode) =>
    axios.delete(`${API_BASE_URL}/api/pref-partners/${officeCode}/${partnerCode}`);


//  Child Organization Related API's
export const fetchChildOrganizations = async (parentId) =>
    axios.get(`${API_BASE_URL}/api/organizations/getchildorg/${parentId}`, {
        headers: {Authorization: `Bearer ${getAuthToken()}`},
    });

export const addChildOrganization = async (officeCode, data) =>
    axios.post(
        `${API_BASE_URL}/api/organizations/child/${officeCode}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            },
        }
    );
export const checkOfficeCode = async (officeCode) =>
    axios.post(
        `${API_BASE_URL}/api/onboarding/check-office-code?officeCode=${officeCode}`,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "application/json",
            }
        }
    );


// Role APIs
export const fetchAllRoles = async (token) => {
    const orgTypesRaw = localStorage.getItem("organizationTypes");
    const orgTypes = orgTypesRaw ? JSON.parse(orgTypesRaw) : [];

    const requests = orgTypes.map(keyword =>
        axios.get(`${API_BASE_URL}/api/role/search`, {
            params: {keyword, active: true},
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        })
    );

    const responses = await Promise.all(requests);
    const allRoles = responses.flatMap(res => res.data); // Flatten nested arrays

    // Remove duplicates by role.id
    const uniqueRoles = Array.from(
        new Map(allRoles.map(role => [role.id, role])).values()
    );

    return {data: uniqueRoles}; // Match original response structure
};


export const updateUserRole = async (userEmail, roleId, checked, token) => {
    const url = `${API_BASE_URL}/auth/user/${userEmail}/roles/${roleId}`;
    if (checked) {
        return axios.post(url, {}, {
            headers: {Authorization: `Bearer ${token}`}
        });
    } else {
        return axios.delete(url, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
};

// Office APIs
export const fetchAllOffices = async (token) =>
    axios.get(`${API_BASE_URL}/auth/user/getOrganizations`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "application/json",
        },
    });
export const fetchChildOffices = async (parentOfficeCode, token) =>
    axios.get(`${API_BASE_URL}/api/organizations/getchildorg/${parentOfficeCode}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "application/json",
        },
    });

export const updateUserOffice = async (userEmail, officeCode, checked, token) => {
    const endpoint = checked ? "add-user" : "remove-user";
    const url = `${API_BASE_URL}/api/organizations/${endpoint}?officeCode=${officeCode}&userEmail=${encodeURIComponent(userEmail)}`;
    return axios.post(url, {}, {
        headers: {Authorization: `Bearer ${getAuthToken()}`}
    });
};


//location management
export const addChildLocation = async (parentRef, token, data) =>
    axios.post(`${API_BASE_URL}/api/locations/addChildLocation/${parentRef}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

export const fetchEventsByCalendarRef = async (calendarRefId) => {
    const res = await axios.get(
        `${API_BASE_URL}/api/events/by-cal-ref/${calendarRefId}`,
        {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                Accept: "application/json",
            },
        }
    );
    return res.data;
};


export const fetchLocation = async (officeCode, token) =>
    axios.get(`${API_BASE_URL}/api/locations/by-office-code/${officeCode}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

export const fetchLocationsByOfficeCodes = async () => {
    return axios.get(`${API_BASE_URL}/api/locations/by-office-codes?${getOfficeCodes()}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*"
        }
    });
};


export const fetchLocationsByGrouped = async () => {
    return axios.get(`${API_BASE_URL}/api/locations/grouped`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*"
        }
    });
};

export const fetchChildrenByLocationRef = async (locationRef) => {
    const token = Cookies.get("authToken") || localStorage.getItem("authToken");
    if (!locationRef || !token) throw new Error("Missing locationRef or authToken");

    return axios.get(`${API_BASE_URL}/api/locations/children/by-ref?locationRef=${encodeURIComponent(locationRef)}`, {
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "*/*"
        }
    });
};
// Fetch locations, then fetch children using the first location's locationRef
export const fetchLocationsAndChildren = async (officeCode, token) => {
    try {
        const res = await fetchLocation(officeCode, token);
        const locations = res.data;
        if (locations && locations.length > 0 && locations[0].locationRef) {
            const locationRef = locations[0].locationRef;
            const childrenRes = await axios.get(
                `${API_BASE_URL}/api/locations/children/by-ref?locationRef=${locationRef}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );
            return {
                locations,
                children: childrenRes.data,
            };
        } else {
            return {locations, children: []};
        }
    } catch (error) {
        // Handle error as needed
        return {locations: [], children: []};
    }
};